var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Icon from '../../../common/UIToolKit/Icon.vue';
import Popper from 'popper.js';
var UiPopupMenu = /** @class */ (function (_super) {
    __extends(UiPopupMenu, _super);
    function UiPopupMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isOpen = false;
        _this.popper = null;
        return _this;
    }
    UiPopupMenu.prototype.clickOutside = function (evt) {
        if (!evt.composedPath().includes(this.$el)) {
            this.close();
        }
    };
    UiPopupMenu.prototype.toggle = function () {
        if (this.isOpen) {
            return this.close();
        }
        this.open();
    };
    UiPopupMenu.prototype.close = function () {
        this.isOpen = false;
        document.removeEventListener('click', this.clickOutside);
    };
    UiPopupMenu.prototype.open = function () {
        this.isOpen = true;
        this.popper = new Popper(this.$el, this.$refs.container, {
            placement: this.position,
            modifiers: {
                offset: { offset: '0, 10' },
            },
        });
        document.addEventListener('click', this.clickOutside);
    };
    var _a;
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], UiPopupMenu.prototype, "icon", void 0);
    __decorate([
        Prop({ default: 'bottom-end' }),
        __metadata("design:type", typeof (_a = typeof Popper !== "undefined" && Popper.Placement) === "function" ? _a : Object)
    ], UiPopupMenu.prototype, "position", void 0);
    UiPopupMenu = __decorate([
        Component({
            components: {
                Icon: Icon,
            },
        })
    ], UiPopupMenu);
    return UiPopupMenu;
}(Vue));
export default UiPopupMenu;
